export var DECIMALS;
(function(DECIMALS) {
    DECIMALS[DECIMALS["WEI"] = 18] = "WEI";
    DECIMALS[DECIMALS["YOCTO"] = 24] = "YOCTO";
    DECIMALS[DECIMALS["LAMPORT"] = 9] = "LAMPORT";
})(DECIMALS || (DECIMALS = {}));

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnVtcy9kZWNpbWFscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBERUNJTUFMUyB7XG4gIFdFSSA9IDE4LFxuICBZT0NUTyA9IDI0LFxuICBMQU1QT1JUID0gOSxcbn1cbiJdLCJuYW1lcyI6WyJERUNJTUFMUyJdLCJyYW5nZU1hcHBpbmdzIjoiOzs7OzsiLCJtYXBwaW5ncyI6IjtVQUFZQTs7OztHQUFBQSxhQUFBQSJ9